import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip
} from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import { AuthenticationService, EquipamentoService } from 'src/app/services';
import { IProducao } from 'src/app/interfaces/equipamento/IProducao';
import { IEquipamento } from 'src/app/interfaces';
import { ENVIRONMENT } from 'src/app/constants';
import { Environment } from 'src/app/types';
import { ModalEditarEquipamentoLocalizacaoComponent } from '../../../components/modal-editar-equipamento-localizacao/modal-editar-equipamento-localizacao.component';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};

export interface IChamados {
  codigoOS: string;
  dataAbertura: Date;
  solicitante: string;
  status: string;
  motivo: string;
}

@Component({
  selector: 'app-listar-equipamentos-detalhes',
  templateUrl: './listar-equipamentos-detalhes.component.html',
  styleUrls: ['./listar-equipamentos-detalhes.component.scss']
})
export class ListarEquipamentosDetalhesComponent implements OnInit, OnDestroy {
  @ViewChild('chart') chart: ChartComponent;

  @ViewChild(ModalEditarEquipamentoLocalizacaoComponent)
  modalEditarEquipamentoLocalizacao: ModalEditarEquipamentoLocalizacaoComponent;

  chamados: IChamados[];
  subscriptions$ = new Subscription();
  detalheEquipamento: IEquipamento;
  chartOptions: Partial<ChartOptions> | any;
  producao: IProducao[];
  params: Params;
  token = this.authenticationService.obterToken();

  // Permissoes
  autorizacoes: IAutorizacoes;

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];

    console.log('this.autorizacoes');
    console.log(this.autorizacoes);
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private service: EquipamentoService,
    @Inject(ENVIRONMENT) public environment: Environment
  ) {}

  criarGrafico() {
    this.chartOptions = {
      series: [{ data: [] }],
      chart: {
        type: 'bar',
        height: 250,
        toolbar: {
          show: true,
          tools: {
            download: false
          }
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%'
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez'
        ]
      },
      yaxis: {
        title: {
          text: ''
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        enabled: false
      }
    };
  }
  getProducaoEquipamento() {
    this.subscriptions$.add(
      this.service
        .getProducaoEquipamento(this.params.numSerie)
        .subscribe(({ data }) => {
          this.producao = data;
          this.atualizarDadosDoGrafico();
        })
    );
  }
  atualizarDadosDoGrafico() {
    this.chartOptions.series[0].data = this.producao.map(
      (item) => item.producao
    );
  }
  getDetalhesEquipamentos() {
    this.subscriptions$.add(
      this.service
        .getEquipamentos({
          idUsuario: this.token.id,
          codContrato: [this.params.codContrato],
          numserie: this.params.numSerie,
          TipoUsuario: this.token.tipoUsuario,
          paginar: false
        })
        .subscribe(({ data }) => {
          this.detalheEquipamento = data.registros[0];
        })
    );
  }
  getHistoricoChamados() {
    this.subscriptions$.add(
      this.service.getHistoricoChamados(this.params.numSerie).subscribe({
        next: (response) => {
          this.chamados = response.data;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }

  ngOnInit(): void {
    this.params = this.activatedRoute.snapshot.params;

    this.getDetalhesEquipamentos();
    this.getHistoricoChamados();
    this.getProducaoEquipamento();
    this.criarGrafico();
    this.gerenciarPermissoesTela();
  }

  editarLocalizacao(equipamento: IEquipamento) {
    this.modalEditarEquipamentoLocalizacao.abrirModal(equipamento);
  }
}
